<div class="search-modal">
  <!-- Search Input -->
  <div class="search-input-wrapper">
    <fa-icon [icon]="searchIcon" class="search-icon"></fa-icon>
    <input
      #searchInput
      type="text"
      class="search-input"
      placeholder="Search documents and plans..."
      [(ngModel)]="searchQuery"
      (ngModelChange)="onSearch()"
      autocomplete="off"
    />
    @if (isSearching) {
      <span class="spinner-border spinner-border-sm loading-spinner"></span>
    }
    <button class="close-btn" (click)="activeModal.dismiss()" title="Close (Esc)">
      <fa-icon [icon]="closeIcon"></fa-icon>
    </button>
  </div>

  <!-- Results -->
  <div class="search-results" #resultsContainer>
    @if (hasResults()) {
      <!-- Documents section -->
      @if (documentResults.length > 0) {
        <div class="result-category">
          <fa-icon [icon]="documentIcon" class="me-2"></fa-icon>
          Documents
        </div>
        @for (doc of documentResults; track doc.id; let i = $index) {
          <a
            class="search-result-item"
            href="javascript:void(0)"
            [class.selected]="isSelected('document', i)"
            (click)="selectDocumentResult(doc)"
          >
            <span class="result-name">{{ doc.name }}</span>
            @if (doc.type && doc.type !== "file") {
              <span class="result-type badge bg-light text-muted ms-2">{{
                doc.type
              }}</span>
            }
          </a>
        }
      }

      <!-- Plans section -->
      @if (planResults.length > 0) {
        <div class="result-category">
          <fa-icon [icon]="planIcon" class="me-2"></fa-icon>
          Plans
        </div>
        @for (plan of planResults; track plan.id; let i = $index) {
          <a
            class="search-result-item"
            href="javascript:void(0)"
            [class.selected]="isSelected('plan', i)"
            (click)="selectPlanResult(plan)"
          >
            <span class="result-name">{{ plan.planner_name }}</span>
            @if (plan.date) {
              <span class="result-date text-muted ms-2">{{
                formatDate(plan.date)
              }}</span>
            }
            @if (plan.content) {
              <span class="result-preview text-muted d-block small">{{
                truncateContent(plan.content)
              }}</span>
            }
          </a>
        }
      }
    } @else if (hasSearched && searchQuery.trim() && !isSearching) {
      <div class="no-results">
        <p class="text-muted m-0">No results found for "{{ searchQuery }}"</p>
      </div>
    } @else if (!hasSearched) {
      <div class="search-hint">
        <p class="text-muted m-0">Start typing to search documents and plans</p>
      </div>
    }
  </div>
</div>
